<template>
  <div class="wrapper">
    <iframe
      :src="url"
      class="responsive-iframe"
      id="itab"
      style="min-height: 96vh"
    />
  </div>
</template>

<script>
import { mapActions, mapMutations } from "vuex";
export default {
  props: {
    url: {
      type: String,
      required: true,
    },
    id: {
      type: String,
      required: true,
    },
  },
  data() {
    return {};
  },
  computed: {},
  methods: {
    ...mapActions({
      removeTab: "tabs/removeTab",
    }),
    ...mapMutations({
      changeCurrentTab: "tabs/changeCurrentTab",
    }),
    fixFrameHeight() {
      const bTabs = document.querySelector(".b-tabs");
      const winH = window.innerHeight;
      const iTab = document.querySelector("#iTab");
      if (iTab)
        iTab.style.height = (winH - bTabs.getBoundingClientRect().height) + "px";
    },
  },
  mounted() {
    this.fixFrameHeight();

    window.document.body.addEventListener(
      "closeTab" + this.id,
      () => {

        const currentIndex = this.$store.state.tabs.currentTab;
        const closingIndex = this.$store.state.tabs.tabs.findIndex((tab) => tab.id === this.id);

        console.log("Closing tab with ID " + this.id);
        this.removeTab(this.id);

        if (currentIndex >= closingIndex)
          this.$nextTick(() => {this.changeCurrentTab(currentIndex - 1)});
      },
      {
        once: true,
      }
    );

    window.addEventListener("resize", () => {
      this.fixFrameHeight();
    });
  },
};
</script>

<style lang="scss">
.wrapper {
  position: relative;
  width: 100%;
  & .responsive-iframe {
    width: 100%;
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
  }
}
</style>
